import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function ModalQuestionsPreview({
  children,
  show,
  setShowModal,
}) {
  const { questions } = useSelector((store) => store.assessments);
  const { answersSaved } = useSelector((store) => store.sessions);
  const handleClose = () => setShowModal(false);

  return (
    <Modal
      show={show}
      onHide={() => setShowModal(false)}
      aria-label={`Modal with preview questions`}
      className={"inter"}
    >
      <Modal.Header closeButton>
        <Modal.Title>These are your answers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className={"text-muted list-decimal px-4 space-y-3"}>
          {questions &&
            questions.map((section) => {
              return section?.questions?.map((questionGroup) => {
                return questionGroup?.questions?.map((question, i) => {
                  const answer = answersSaved.find(
                    (a) => a.qid === question.qid
                  );
                  let selectedIds = [];

                  if (answer?.answercontent?.multichoice) {
                    selectedIds = answer.answercontent.multichoice;
                  } else if (answer?.answercontent?.singlechoice) {
                    selectedIds = [answer.answercontent.singlechoice];
                  }

                  const selectedOptions = question.options.filter((opt) =>
                    selectedIds.includes(opt.qoid)
                  );

                  return (
                    <li key={i}>
                      <p className="truncate">{decode(question?.question)}</p>
                      {selectedOptions.length > 0 ? (
                        <ul className="list-disc pl-4">
                          {selectedOptions.map((opt, j) => (
                            <li key={j} className="font-bold">
                              {decode(opt.opttext)}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="italic text-sm text-gray-400">
                          No answer selected
                        </p>
                      )}
                    </li>
                  );
                });
              });
            })}
        </ul>
        {children}
      </Modal.Body>
      <Modal.Footer className={"flex justify-between"}>
        <Button
          className="px-3 py-2 inter text-white"
          variant="primary"
          onClick={handleClose}
        >
          Continue Assessment
        </Button>
        {/* <Button
          className="px-3 py-2 inter text-white"
          variant="dark"
          color="inherit"
          onClick={handleSubmit}
        >
          {button}
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
}
